module.exports = __webpack_public_path__ + "static/brush-mixtape-6e6d6f7b8d513e7c359c60591746e6a5.png";